import React, {
  useRef,
  Fragment,
  useState,
  useEffect,
  useCallback,
} from 'react'
import { SubMenuItem } from '../SidebarSelfServe/MenuItem'
import { Link, useRouteMatch } from 'react-router-dom'
import classNames from 'classnames'
import { EDDM_SIGNUP } from '../../shared/constants'
import { useFeatureFlags } from '../../Context/FeatureFlagsContext'
import SidebarDashboardIcon from '../../Assets/Images/icons/sidebarDashboard'
import { DMSidebarIcon } from '../../Assets/Images/icons/DMSidebarIcon'
import { H2HSidebarIcon } from '../../Assets/Images/icons/H2HSidebarIcon'
import { D2DSidebarIcon } from '../../Assets/Images/icons/D2DSidebarIcon'
import SidebarHomeIcon from '../../Assets/Images/icons/sidebarHome'
import SidebarHelpIcon from '../../Assets/Images/icons/sidebarHelp'
import { EDDMLogo } from '../../Assets/Images/icons/EDDMlogo'
import { PATHS } from '../../Config/Routing/paths'
import { CONFIG } from '../../Config/config'
import { authorization } from '../../Module/Auth/Auth'
import SidebarSettingsIcon from '../../Assets/Images/icons/sidebarSettings'
import SelfServeClientChat from '../SelfServeClientChat/container'
import injectStyles from 'react-jss'
import ActionSheet from 'actionsheet-react'
import { style } from './styles'
import { BurgerMenuIcon } from '../../Assets/Images/icons/burger'
import PromofyHeaderSelfServe from '../../Assets/Images/icons/oppiziHeaderSelfServe'
import LogoutIcon from '../../Assets/Images/icons/logoutNewDesign'
import { If } from '../../Components/IfElse'
import { VerifyEmail } from '../../Components/Alerts'
import AimIcon from '../../Assets/Images/icons/aimIcon'
import MarketingTools from '../../Assets/Images/icons/MarketingTools'
import AudienceAndVariableIcon from '../../Assets/Images/icons/audienceAndVariableIcon'

const ITEM_TYPES = {
  HOME: 'HOME',
  DASHBOARD: 'DASHBOARD',
  ACTIVE_CAMPAIGNS: 'ACTIVE_CAMPAIGNS',
  DIRECT_MAIL: 'DIRECT_MAIL',
  DOOR_TO_DOOR: 'DOOR_TO_DOOR',
  HAND_TO_HAND: 'HAND_TO_HAND',
  INSERTS: 'INSERTS',
  USER_MANAGEMENT: 'USER_MANAGEMENT',
  HELP: 'HELP',
  INTEGRATIONS: 'INTEGRATIONS',
  SETTINGS: 'SETTINGS',
  MARKETING_TOOLS: 'MARKETING_TOOLS',
  AUDIENCE_AND_VARIABLE: 'AUDIENCE_AND_VARIABLE',
}

const getInitialActiveElement = ({ history, match }) => {
  if (
    history.location.pathname.startsWith(
      `${match.path}${PATHS.dashboard.clientCampaigns}`,
    )
  ) {
    if (history.location.pathname.endsWith(`${PATHS.campaignsTypes.d2d}`)) {
      return ITEM_TYPES.DOOR_TO_DOOR
    } else if (
      history.location.pathname.endsWith(`${PATHS.campaignsTypes.h2h}`)
    ) {
      return ITEM_TYPES.HAND_TO_HAND
    } else if (
      history.location.pathname.endsWith(`${PATHS.campaignsTypes.dm}`)
    ) {
      return ITEM_TYPES.DIRECT_MAIL
    } else if (
      history.location.pathname.endsWith(`${PATHS.campaignsTypes.inserts}`)
    ) {
      return ITEM_TYPES.INSERTS
    } else {
      return ITEM_TYPES.DASHBOARD
    }
  } else if (
    history.location.pathname.startsWith(
      `${match.path}${PATHS.dashboard.userManagement}`,
    ) ||
    history.location.pathname.startsWith(
      `${match.path}${PATHS.dashboard.profile}`,
    )
  ) {
    return ITEM_TYPES.USER_MANAGEMENT
  } else if (
    history.location.pathname.startsWith(
      `${match.path}${PATHS.dashboard.integrations}`,
    )
  ) {
    return ITEM_TYPES.INTEGRATIONS
  } else if (
    history.location.pathname.startsWith(
      `${match.path}${PATHS.dashboard.clientSettings}`,
    )
  ) {
    return ITEM_TYPES.SETTINGS
  } else {
    return ITEM_TYPES.HOME
  }
}

const ActionSheetNavBar = ({
  toggleAssistant,
  children,
  history,
  user,
  classes,
  img,
  userName,
  clientName,
  email,
  sendVerificationEmail,
  verified,
}) => {
  const ref = useRef()
  const match = useRouteMatch()
  const { client } = authorization.getUser()
  const isEddmSignup = client.createdBy === EDDM_SIGNUP
  const isClientAdmin = authorization.isClientAdmin()
  const [activeElement, setActiveElement] = useState(
    getInitialActiveElement({ history, match }),
  )

  const { isAdmEnabled } = useFeatureFlags()

  const isChatEnabled = client && client.countryId
  const isQrSignup = client.createdBy === 'qr_signup'

  // Check if the current route is the Flyer builder (DesignEditor)
  const isFlyerBuilder = history.location.pathname.includes(
    '/design-management/design/',
  )

  useEffect(() => {
    if (getInitialActiveElement({ history, match }) !== activeElement) {
      setActiveElement(getInitialActiveElement({ history, match }))
    }
  }, [history])

  const handleOpen = () => {
    ref.current.open()
  }

  const handleClose = () => {
    ref.current.close()
  }

  const getItems = useCallback(
    activeElement => {
      const eddmCampaignRoutes = [
        {
          icon: (
            <SidebarDashboardIcon
              isActive={ITEM_TYPES.DASHBOARD === activeElement}
            />
          ),
          name: 'Active campaigns',
          type: ITEM_TYPES.DASHBOARD,
          href: `${match.path}${PATHS.dashboard.clientCampaigns}${
            client ? `/${client.id}` : ''
          }${PATHS.campaignsTypes.active}`,
          onClick: e => {
            const isCtrlClick = e.ctrlKey || e.metaKey
            if (activeElement !== ITEM_TYPES.DASHBOARD && !isCtrlClick) {
              setActiveElement(ITEM_TYPES.DASHBOARD)
            }
          },
        },
        ...(client.countryId === 14
          ? [
              {
                icon: (
                  <DMSidebarIcon
                    isActive={ITEM_TYPES.DIRECT_MAIL === activeElement}
                  />
                ),
                name: 'Direct mail',
                type: ITEM_TYPES.DIRECT_MAIL,
                href: isAdmEnabled
                  ? ''
                  : `${match.path}${PATHS.dashboard.clientCampaigns}${
                      client ? `/${client.id}` : ''
                    }${PATHS.campaignsTypes.dm}`,
                onClick: e => {
                  const isCtrlClick = e.ctrlKey || e.metaKey
                  if (
                    activeElement !== ITEM_TYPES.DIRECT_MAIL &&
                    !isCtrlClick
                  ) {
                    setActiveElement(ITEM_TYPES.DIRECT_MAIL)
                  }
                },
                subLinks: isAdmEnabled
                  ? [
                      {
                        name: 'Addressed Direct Mail',
                        href: `${match.path}${PATHS.dashboard.clientCampaigns}${
                          client ? `/${client.id}` : ''
                        }${PATHS.campaignsTypes.dmAdm}`,
                      },
                      {
                        name: 'Every Door (EDDM)',
                        href: `${match.path}${PATHS.dashboard.clientCampaigns}${
                          client ? `/${client.id}` : ''
                        }${PATHS.campaignsTypes.dmEddm}`,
                      },
                    ]
                  : null,
              },
            ]
          : []),
        {
          icon: (
            <H2HSidebarIcon
              isActive={ITEM_TYPES.HAND_TO_HAND === activeElement}
            />
          ),
          name: 'Flyering',
          type: ITEM_TYPES.HAND_TO_HAND,
          href: `${match.path}${PATHS.dashboard.clientCampaigns}${
            client ? `/${client.id}` : ''
          }${PATHS.campaignsTypes.h2h}`,
          onClick: e => {
            const isCtrlClick = e.ctrlKey || e.metaKey
            if (activeElement !== ITEM_TYPES.HAND_TO_HAND && !isCtrlClick) {
              setActiveElement(ITEM_TYPES.HAND_TO_HAND)
            }
          },
        },
        {
          icon: (
            <D2DSidebarIcon
              isActive={ITEM_TYPES.DOOR_TO_DOOR === activeElement}
            />
          ),
          name: 'Door to door',
          type: ITEM_TYPES.DOOR_TO_DOOR,
          href: `${match.path}${PATHS.dashboard.clientCampaigns}${
            client ? `/${client.id}` : ''
          }${PATHS.campaignsTypes.d2d}`,
          onClick: e => {
            const isCtrlClick = e.ctrlKey || e.metaKey
            if (activeElement !== ITEM_TYPES.DOOR_TO_DOOR && !isCtrlClick) {
              setActiveElement(ITEM_TYPES.DOOR_TO_DOOR)
            }
          },
        },
        {
          icon: <AimIcon isActive={ITEM_TYPES.INSERTS === activeElement} />,
          name: 'Inserts marketing',
          type: ITEM_TYPES.INSERTS,
          href: `${match.path}${PATHS.dashboard.clientCampaigns}${
            client ? `/${client.id}` : ''
          }${PATHS.campaignsTypes.inserts}`,
          onClick: e => {
            const isCtrlClick = e.ctrlKey || e.metaKey
            if (activeElement !== ITEM_TYPES.INSERTS && !isCtrlClick) {
              setActiveElement(ITEM_TYPES.INSERTS)
            }
          },
        },
        {
          icon: (
            <AudienceAndVariableIcon
              isActive={ITEM_TYPES.AUDIENCE_AND_VARIABLE === activeElement}
            />
          ),
          name: 'Audience & Variable',
          type: ITEM_TYPES.AUDIENCE_AND_VARIABLE,
          href: '',
          onClick: e => {
            const isCtrlClick = e.ctrlKey || e.metaKey
            if (
              activeElement !== ITEM_TYPES.AUDIENCE_AND_VARIABLE &&
              !isCtrlClick
            ) {
              setActiveElement(ITEM_TYPES.AUDIENCE_AND_VARIABLE)
            }
            window.open(
              `${CONFIG.NEXT_BASE_URL}${PATHS.main.dashboard}${
                client ? `/${client.id}` : ''
              }${PATHS.dashboard.audienceAndVariable}`,

              '_self',
            )
          },
        },
      ]
      let items = [
        ...(isQrSignup
          ? [
              {
                icon: <MarketingTools />,
                name: 'Marketing Tools',
                type: ITEM_TYPES.MARKETING_TOOLS,
                href: '',
                onClick: () => {
                  window.open(
                    `${PATHS.external.tools}/home?client_id=${user.client.id}`,
                    '_self',
                  )
                },
              },
            ]
          : []),
        {
          icon: (
            <SidebarSettingsIcon
              isActive={ITEM_TYPES.SETTINGS === activeElement}
            />
          ),
          name: 'Settings',
          type: ITEM_TYPES.SETTINGS,
          href: `${match.path}${PATHS.dashboard.clientSettings}`,
          onClick: e => {
            const isCtrlClick = e.ctrlKey || e.metaKey
            if (activeElement !== ITEM_TYPES.SETTINGS && !isCtrlClick) {
              setActiveElement(ITEM_TYPES.SETTINGS)
            }
          },
        },
      ]

      items = eddmCampaignRoutes.concat(items)

      if (client.isSelfServeEnabled) {
        items.unshift({
          icon: (
            <SidebarHomeIcon isActive={ITEM_TYPES.HOME === activeElement} />
          ),
          name: 'Home',
          type: ITEM_TYPES.HOME,
          href: `${match.path}${PATHS.dashboard.home}`,
          onClick: e => {
            const isCtrlClick = e.ctrlKey || e.metaKey
            if (activeElement !== ITEM_TYPES.HOME && !isCtrlClick) {
              setActiveElement(ITEM_TYPES.HOME)
            }
          },
        })
        items.push({
          icon: (
            <SidebarHelpIcon isActive={ITEM_TYPES.HELP === activeElement} />
          ),
          name: 'Help Center',
          type: ITEM_TYPES.HELP,
          href: '',
          onClick: () => {
            window.open('https://selfserve.oppizi.com/', '_blank')
          },
        })
      }

      return items
    },
    [activeElement, client],
    // countrySettings
  )
  const handleRedirect = () => {
    history.push(`${match.path}${PATHS.dashboard.profile}`)
  }
  const handleLogOut = () => {
    authorization.logout()
    history.push(PATHS.main.login)
    handleClose()
  }

  return (
    <Fragment>
      <div className={classes.root}>
        <div className={classes.main}>
          {isEddmSignup ? <EDDMLogo /> : <PromofyHeaderSelfServe />}
          <button
            onClick={handleOpen}
            style={{ background: '#F9F9FF', border: 'none' }}
          >
            <BurgerMenuIcon />
          </button>
        </div>
        <If condition={!verified}>
          <VerifyEmail
            email={email}
            sendVerificationEmail={sendVerificationEmail}
          />
        </If>
        <ActionSheet ref={ref}>
          <div className={classNames(classes.lineContainer)}>
            <div className={classNames(classes.line)} />
          </div>
          <div
            onClick={e => {
              handleRedirect(e)
              handleClose(e)
            }}
            className={classNames(classes.user, { [classes.open]: open })}
          >
            <div className={classes.userPicture}>
              <img src={img} alt="User profile" />
            </div>
            <div className={classes.names} cypress_id={'headerSelfServeNames'}>
              <div
                className={classes.clientName}
                cypress_id={'headerSelfServeClientName'}
              >
                {clientName}
              </div>
              <div
                className={classes.userName}
                cypress_id={'headerSelfServeUserName'}
              >
                <div>{userName}</div>
              </div>
            </div>
          </div>
          <div className={classNames(classes.itemsWrapper)}>
            {getItems(activeElement).map(item => {
              if (!isClientAdmin && item.type === ITEM_TYPES.USER_MANAGEMENT) {
                return null
              }
              const hasSublinks = item.subLinks && item.subLinks.length > 0
              const isActive = activeElement === item.type

              return item.href ? (
                <Link
                  key={item.name}
                  to={item.href || ''}
                  className={classes.link}
                >
                  <div
                    className={classes.item}
                    onClick={e => {
                      item.onClick(e)
                      handleClose(e)
                    }}
                  >
                    <div
                      className={classNames(classes.logoWrap, {
                        [classes.active]: isActive,
                      })}
                    >
                      {item.icon}
                      {open && (
                        <div
                          className={classNames(classes.nameWrap, {
                            [classes.activeText]: isActive,
                          })}
                        >
                          {item.name}
                        </div>
                      )}
                    </div>
                  </div>
                </Link>
              ) : (
                <Fragment key={item.name}>
                  <div className={classes.item} onClick={e => item.onClick(e)}>
                    <div
                      className={classNames(classes.logoWrap, {
                        [classes.active]: isActive,
                      })}
                    >
                      {item.icon}
                      {open && (
                        <div
                          className={classNames(classes.nameWrap, {
                            [classes.activeText]: isActive,
                          })}
                        >
                          {item.name}
                        </div>
                      )}
                    </div>
                  </div>
                  {isActive && hasSublinks && open && (
                    <div className={classes.submenuContainer}>
                      {item.subLinks.map(subLink => (
                        <SubMenuItem
                          key={subLink.name}
                          item={subLink}
                          isActive={false}
                          classes={classes}
                          onClick={() => {
                            handleClose()
                          }}
                        />
                      ))}
                    </div>
                  )}
                </Fragment>
              )
            })}
          </div>
          <div
            className={classNames(classes.logoutContainer)}
            onClick={handleLogOut}
          >
            <LogoutIcon />
            <p className={classNames(classes.nameWrap)}>Log out</p>
          </div>
        </ActionSheet>
        <main className={classNames(classes.mainContent)}>{children}</main>

        {isChatEnabled && !isFlyerBuilder ? (
          <SelfServeClientChat
            user={user}
            client={user.client}
            countryId={String(user.client.countryId)}
            toggleAssistant={toggleAssistant}
          />
        ) : null}
      </div>
    </Fragment>
  )
}

export default injectStyles(style)(ActionSheetNavBar)
